angular.module('SpidApp')

.controller('UserParamsController',
        ['BASE_PUBLIC_URL', '$scope', '_', 'UserService', 'Toaster', '$uibModal','User',
function (BASE_PUBLIC_URL,   $scope,   _,   UserService,   Toaster,   $uibModal, User) {
        	
	$scope.appControllerOver.then(function () {
		$scope.saveUsers = function () {
			var users = $scope.users;
			return UserService.bulkSave(users).then(function () {
				Toaster.show('Les utilisateurs ont été sauvegardés')
			}).catch(function (error) {
				console.error('UserService::bulkSave() - ', error)
			})
		}
		
		var fetchUsers = function () {
			return UserService.all().then(function(users) {

				for (var key in users) {
					if (users.hasOwnProperty(key)) {
						users[key] = new User({id:users[key].id,username:atob(users[key].username),firstname:atob(users[key].firstname),lastname:atob(users[key].lastname),mail:atob(users[key].mail),roles:users[key].roles,agency_ids:users[key].agency_ids,n:users[key].n,tmp_password:users[key].tmp_password,is_actif:users[key].is_actif,state_password:users[key].state_password});
						
					}
				}
				
				$scope.users = users;//_.where(users, {agency_id: $scope.agency.id});
			});
		}

		fetchUsers()
		$scope.restoreUsers = function () {
			return fetchUsers().then(function () {
				Toaster.warning('Les utilisateurs ont été rechargés')
			})
		}
		
		$scope.isDisplayed = function (user) {
			if (!user) {
				return
			}
			
			var localAgencyId = $scope.configs.agencyId
			var userAgencyIds = user.getAgencyIds()
			
			return $scope.user.isSuperviseur() || userAgencyIds.lastIndexOf(localAgencyId + '') > -1
		}
		
		$scope.changeAgencies = function (user) {
			if (!user) {
				return
			}
			
			$scope.selectedUser = user
			$uibModal.open({
				animation   : $scope.animationsEnabled,
				templateUrl : BASE_PUBLIC_URL + '/views/partials/change-user-agencies.html',
				controller  : 'ChangeUserAgenciesController',
				scope       : $scope
			}).result.then(function (response) {
				user.agency_ids = response
				delete $scope.selectedUser
			})
		}
		
		$scope.deactivate = function (userId) {
			if (userId === null || userId === undefined) {
				return
			}
			
			return UserService.deactivate(userId).then(function () {
				Toaster.show('L\'utilisateur a été supprimé')
				
				return $scope.restoreUsers()
			}).catch(function () {
				Toaster.danger('Impossible de supprimer l\'utilisateur')
			})
		}
	})
}])
